import React from 'react';
import { Box, Card, CardContent, Stack, SvgIcon, Typography } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import Client from './../Client';
import BackofficeReportsApi from './backofficeReportsApi';

function thousandsSeparator(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

class OverviewTotalCustomers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      tclients: [],
      filterData: {}
    };
  }

  componentDidMount() {
    let queryData = {};
    let data = BackofficeReportsApi.getClientsSummary(this.state.client, queryData);

    if (data) {
      this.setState({ tclients: data });
    }

    this.setState({ filterData: queryData });
  }

  render() {
    let clientsDataT = 0;
    let clientsDataLM = 0;
    let difference = 0;
    let dif_positive = false;

    if (this.state.tclients) {
      let tclients = this.state.tclients;

      if (tclients.Total_clienti !== undefined) {
        clientsDataT = parseInt(tclients.Total_clienti);
      }

      if (tclients.Total_clienti_prev_30d !== undefined) {
        clientsDataLM = parseInt(tclients.Total_clienti_prev_30d);
      }

      if (clientsDataLM !== 0) {
        difference = parseFloat((clientsDataT / clientsDataLM - 1) * 100).toFixed(1);
      } else {
        difference = 0;
      }

      dif_positive = difference >= 0;
    }

    const displayValue =
      clientsDataT > 1000
        ? thousandsSeparator((clientsDataT / 1000).toFixed(1)) + "K"
        : thousandsSeparator(clientsDataT.toFixed(0));

    return (
      <Card
        sx={{
          overflow: 'hidden',
          position: 'relative',
          borderRadius: { xs: '14px', sm: '16px' },
          height: '100%',
          width: '100%',
          boxSizing: 'border-box',
          boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
          background: 'linear-gradient(180deg, #ffffff 0%, #fbfcff 100%)',
          border: '1px solid rgba(15, 23, 42, 0.06)',
          '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 4,
            background: '#1a237e',
          },
        }}
      >
        <CardContent
          sx={{
            height: '100%',
            boxSizing: 'border-box',
            p: {
              xs: 1.5,
              sm: 1.75,
              md: 2,
            },
            '&:last-child': {
              pb: {
                xs: 1.5,
                sm: 1.75,
                md: 2,
              },
            },
          }}
        >
          <Stack
            sx={{
              height: '100%',
              minHeight: {
                xs: 104,
                sm: 118,
              },
            }}
            justifyContent="space-between"
            spacing={1.25}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                sx={{
                  lineHeight: 1.2,
                  color: '#1a237e',
                  fontWeight: 800,
                  letterSpacing: '.015em',
                  fontSize: {
                    xs: '0.74rem',
                    sm: '0.8rem',
                    md: '0.84rem',
                  },
                  textTransform: 'uppercase',
                }}
              >
                App clients
              </Typography>

              <Typography
                sx={{
                  mt: 0.6,
                  fontWeight: 800,
                  lineHeight: 1,
                  color: '#111827',
                  fontSize: {
                    xs: '2rem',
                    sm: '2.2rem',
                    md: '2.35rem',
                  },
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {displayValue}
              </Typography>
            </Box>

            <Stack
              alignItems="center"
              direction="row"
              spacing={0.75}
              sx={{ minWidth: 0 }}
            >
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.35,
                  px: 0.7,
                  py: 0.25,
                  borderRadius: 999,
                  bgcolor: dif_positive
                    ? 'rgba(46, 125, 50, 0.10)'
                    : 'rgba(211, 47, 47, 0.10)',
                  flexShrink: 0,
                }}
              >
                <SvgIcon
                  color={dif_positive ? 'success' : 'error'}
                  sx={{ fontSize: 17 }}
                >
                  {dif_positive ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
                </SvgIcon>

                <Typography
                  color={dif_positive ? 'success.main' : 'error.main'}
                  sx={{
                    fontWeight: 800,
                    fontSize: {
                      xs: '0.82rem',
                      sm: '0.88rem',
                    },
                    lineHeight: 1.2,
                  }}
                >
                  {parseFloat(difference).toFixed(0)}%
                </Typography>
              </Box>

              <Typography
                color="text.secondary"
                sx={{
                  fontSize: {
                    xs: '0.76rem',
                    sm: '0.82rem',
                  },
                  lineHeight: 1.25,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  minWidth: 0,
                }}
              >
                last 30d
              </Typography>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    );
  }
}

export default OverviewTotalCustomers;
